import { FormattedMessage } from 'react-intl';
import { FormField } from '../../../../forms/formField/index';
import messages from '../CompanyDetails.messages';

export const CompanyTypeQuestion = (props) => {
    const { onChange } = props;

    return (
        <FormField
            label={<FormattedMessage {...messages.companyType} />}
            name="companyType"
            id="companyType"
            onChangeHandler={onChange}
            disabled={true}
        />
    );
};
